import { Action } from '@ngrx/store';
import { AnnotationsByPage } from '@app/work-order/pdf-markup/pdf-markup-annotation.model';

export enum PdfMarkupActionTypes {
  LoadMarkups = '[PdfMarkup] Load Markups',
  LoadMarkupsSuccess = '[PdfMarkup] Load Markups Success',
  LoadMarkupsFailure = '[PdfMarkup] Load Markups Failure',
  SaveMarkups = '[PdfMarkup] Save Markups',
  SaveMarkupsSuccess = '[PdfMarkup] Save Markups Success',
  SaveMarkupsFailure = '[PdfMarkup] Save Markups Failure',
  DeleteMarkup = '[PdfMarkup] Delete Markup',
  DeleteMarkupSuccess = '[PdfMarkup] Delete Markup Success',
  DeleteMarkupFailure = '[PdfMarkup] Delete Markup Failure',
  ClearMarkupsState = '[PdfMarkup] Clear Markups State',
}

export class LoadMarkups implements Action {
  readonly type = PdfMarkupActionTypes.LoadMarkups;
  constructor(public documentId: string) {}
}

export class LoadMarkupsSuccess implements Action {
  readonly type = PdfMarkupActionTypes.LoadMarkupsSuccess;
  constructor(
    public documentId: string,
    public annotationsByPage: AnnotationsByPage,
  ) {}
}

export class LoadMarkupsFailure implements Action {
  readonly type = PdfMarkupActionTypes.LoadMarkupsFailure;
  constructor(
    public documentId: string,
    public error: string,
  ) {}
}

export class SaveMarkups implements Action {
  readonly type = PdfMarkupActionTypes.SaveMarkups;
  constructor(
    public documentId: string,
    public annotationsByPage: AnnotationsByPage,
  ) {}
}

export class SaveMarkupsSuccess implements Action {
  readonly type = PdfMarkupActionTypes.SaveMarkupsSuccess;
  constructor(
    public documentId: string,
    public annotationsByPage: AnnotationsByPage,
  ) {}
}

export class SaveMarkupsFailure implements Action {
  readonly type = PdfMarkupActionTypes.SaveMarkupsFailure;
  constructor(
    public documentId: string,
    public error: string,
  ) {}
}

export class DeleteMarkup implements Action {
  readonly type = PdfMarkupActionTypes.DeleteMarkup;
  constructor(
    public documentId: string,
    public markupId: string,
  ) {}
}

export class DeleteMarkupSuccess implements Action {
  readonly type = PdfMarkupActionTypes.DeleteMarkupSuccess;
  constructor(
    public documentId: string,
    public markupId: string,
  ) {}
}

export class DeleteMarkupFailure implements Action {
  readonly type = PdfMarkupActionTypes.DeleteMarkupFailure;
  constructor(
    public documentId: string,
    public markupId: string,
    public error: string,
  ) {}
}

export class ClearMarkupsState implements Action {
  readonly type = PdfMarkupActionTypes.ClearMarkupsState;
  constructor(public documentId: string) {}
}

export type PdfMarkupActions =
  | LoadMarkups
  | LoadMarkupsSuccess
  | LoadMarkupsFailure
  | SaveMarkups
  | SaveMarkupsSuccess
  | SaveMarkupsFailure
  | DeleteMarkup
  | DeleteMarkupSuccess
  | DeleteMarkupFailure
  | ClearMarkupsState;
